{
  "name": "@froxz/vite-plugin-s3",
  "type": "module",
  "version": "2.0.5",
  "description": "Allows you to upload files to AWS S3 or any other S3 compatible provider",
  "author": {
    "name": "Sergkei Melingk",
    "email": "sergio11of@gmail.com",
    "url": "https://github.com/SergkeiM"
  },
  "license": "MIT",
  "homepage": "https://github.com/SergkeiM/vite-plugin-s3",
  "repository": "https://github.com/SergkeiM/vite-plugin-s3",
  "bugs": {
    "url": "https://github.com/SergkeiM/vite-plugin-s3/issues"
  },
  "keywords": [
    "vite",
    "s3",
    "vite-plugin",
    "do-spaces"
  ],
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js"
    }
  },
  "main": "./dist/index.js",
  "typesVersions": {
    "*": {
      ".": [
        "./dist/index.d.ts"
      ]
    }
  },
  "files": [
    "dist"
  ],
  "scripts": {
    "lint": "eslint .",
    "lint:fix": "eslint . --fix",
    "clean": "rm -rf dist",
    "dev": "tsup --watch",
    "build": "npm run clean && tsup",
    "prepublishOnly": "npm run build",
    "test": "vitest"
  },
  "peerDependencies": {
    "vite": "^3.1.0 || ^4.0.0 || ^5.0.0 || ^6.0.0 || ^7.0.0"
  },
  "dependencies": {
    "@aws-sdk/client-s3": "^3.0.0",
    "es-toolkit": "^1.39.7",
    "kolorist": "^1.7.0",
    "mime-types": "^3.0.1",
    "recursive-readdir": "^2.2.3"
  },
  "devDependencies": {
    "@antfu/eslint-config": "^4.16.2",
    "@types/mime-types": "^3.0.1",
    "@types/node": "^24.0.10",
    "@types/recursive-readdir": "^2.2.1",
    "@vitest/ui": "^3.2.4",
    "tsup": "^8.5.0",
    "typescript": "^5.8.3",
    "vitest": "^3.2.4"
  }
}
